import { computed, createBlock, openBlock, createSlots, renderList, withCtx, createVNode } from "vue";
import { SETTINGS_UPDATE_EVENT } from "../../lib/constants.js";
import _sfc_main$1 from "./renderer_target.vue.js";
import _sfc_main$2 from "../tools/node.vue.js";
const __default__ = {
  name: "DtcRenderer"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    /**
     * Component to render.
     */
    component: {
      type: Object,
      required: true
    },
    /**
     * Info data object.
     */
    info: {
      type: Object,
      required: true
    },
    /**
     * Options data object.
     */
    options: {
      type: Object,
      required: true
    },
    /**
     * Settings data object.
     */
    settings: {
      type: Object,
      required: true
    },
    library: {
      type: Object,
      required: true
    }
  },
  emits: [
    SETTINGS_UPDATE_EVENT,
    "event"
  ],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const renderedSlots = computed(() => {
      if (!props.options.slots) {
        return null;
      }
      return Object.fromEntries(
        Object.entries(props.options.slots).filter(([, slot]) => slot)
      );
    });
    computed(() => getSetting("background"));
    computed(() => getSetting("positioning"));
    function getSetting(setting) {
      return props.settings.renderer[setting];
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$1, {
        component: __props.component,
        bindings: __props.options.bindings.get(),
        events: __props.info.events,
        onEvent: _cache[0] || (_cache[0] = (event, value) => emit("event", event, value))
      }, createSlots({ _: 2 }, [
        renderList(renderedSlots.value, (slot, name) => {
          return {
            name,
            fn: withCtx(() => [
              createVNode(_sfc_main$2, {
                template: slot,
                library: __props.library
              }, null, 8, ["template", "library"])
            ])
          };
        })
      ]), 1032, ["component", "bindings", "events"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=renderer.vue.js.map
